let allLocs = [];
let data = [];

function getDistance(lng1, lat1, lng2, lat2) {
  const er = 6371e3;
  const l1 = (lat1 * Math.PI) / 180;
  const l2 = (lat2 * Math.PI) / 180;
  const clat = ((lat2 - lat1) * Math.PI) / 180;
  const clng = ((lng2 - lng1) * Math.PI) / 180;

  const a =
    Math.sin(clat / 2) * Math.sin(clat / 2) + Math.cos(l1) * Math.cos(l2) * Math.sin(clng / 2) * Math.sin(clng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  // distance in metres
  const d = er * c;
  return d;
}

async function getPostcodeData(postcode) {
  const url = `https://api.postcodes.io/postcodes/${postcode}`;

  return fetch(url, { method: "get" })
    .then((httpResponse) => {
      if (httpResponse.ok) {
        return httpResponse.json();
      } else {
        return Promise.reject("Error, failed to fetch valid postcode");
      }
    })
    .then((json) => {
      const latLng = { lat: json.result.latitude, lng: json.result.longitude };
      return latLng;
    })
    .catch((err) => {
      return null; // Return null to indicate failure
    });
}

function loadMapScripts(callback) {
  if (document.querySelector('script[src*="plotly"]') && typeof Plotly !== "undefined") {
    if (callback) callback();
    return;
  }

  const ps = document.createElement("script");
  ps.src = "https://cdn.plot.ly/plotly-3.0.1.min.js";
  ps.onload = function () {
    if (callback) callback();
  };
  document.head.appendChild(ps);
}

// Make it globally available
window.loadMapScripts = loadMapScripts;

function loadMap(selected) {
  let mapCentre = selected ?? { lat: 54.589237, lon: -5.127479, zoom: 4 };

  let layout = {
    dragmode: "zoom",
    map: {
      center: {
        lat: mapCentre.lat,
        lon: mapCentre.lng,
      },
      domain: {
        x: [0, 1],
        y: [0, 1],
      },
      style: "outdoors",
      zoom: mapCentre.zoom,
    },
    margin: {
      r: 0,
      t: 0,
      b: 30,
      l: 0,
      pad: 0,
    },
    paper_bgcolor: "#ffffff",
    plot_bgcolor: "#F46F32",
    showlegend: false,
  };

  // Hide loading spinner before rendering map
  loading(false, "mapElement");

  const plotly = Plotly;
  plotly.newPlot("mapElement", data, layout);
}

function loading() {
  // Show spinner
  function showMapSpinner() {
    document.getElementById("mapLoadingSpinner").classList.remove("hideSpinner");
  }

  // Hide spinner
  function hideMapSpinner() {
    document.getElementById("mapLoadingSpinner").classList.add("hideSpinner");
  }

  showMapSpinner();
  setTimeout(() => {
    hideMapSpinner();
  }, 3000);
}

function createMap() {
  // Show loading spinner
  loading();

  fetch("https://cdn.shopify.com/s/files/1/0900/1975/8411/files/MiPetMapData_2026.csv")
    .then((response) => response.text())
    .then((csvText) => {
      const rows = parseCSV(csvText);      
      allLocs = rows;
      let locationsArray = up(rows, "Name");
      let locations = [...new Set(locationsArray)];

      function up(rows, key) {
        return rows.map(function (row) {
          return row[key];
        });
      }

      data = locations.map(function (locations) {
        let rf = rows.filter(function (row) {
          return row.Name === locations;
        });
        const { Name, lat, lng, address } = rf[0];

        return {
          type: "scattermap",
          name: Name,
          lat: up(rf, "lat"),
          lon: up(rf, "lng"),
          text: `${Name}, ${address}`,
          hovertemplate: `    Name: ${Name}    <br>    Address: ${address}    <extra></extra>`,
          hoverlabel: {
            bordercolor: "#F46F32",
            font: {
              color: "#ffffff",
              weight: 600,
            },
          },
          mode: "markers",
          marker: {
            size: 9,
            color: "#F46F32",
            opacity: 0.75,
          },
        };
      });

      loadMap();
    })
    .catch((error) => {
      console.error("Error loading CSV data:", error);

      // Hide loading spinner and show error message
      loading(false, "mapElement");

      const container = document.getElementById("mapElement");
      if (container) {
        container.innerHTML = `
          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 400px;
            background-color: #f8d7da;
            border-radius: 8px;
            border: 2px solid #f5c6cb;
            color: #721c24;
          ">
            <p style="margin: 0; font-size: 16px; font-weight: 500;">
              Failed to load map data. Please try again later.
            </p>
          </div>
        `;
      }
    });
}

function parseCSV(csvText) {
  const text = csvText.trim();
  const rows = [];
  let row = [];
  let field = "";
  let inQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const next = text[i + 1];

    if (inQuotes) {
      if (char === '"' && next === '"') {
        field += '"';
        i++;
      } else if (char === '"') {
        inQuotes = false;
      } else {
        field += char;
      }
      continue;
    }

    if (char === '"') {
      inQuotes = true;
    } else if (char === ",") {
      row.push(field.trim());
      field = "";
    } else if (char === "\n" || char === "\r") {
      if (char === "\r" && next === "\n") i++;
      row.push(field.trim());
      rows.push(row);
      row = [];
      field = "";
    } else {
      field += char;
    }
  }
  row.push(field.trim());
  rows.push(row);

  const h = rows[0];
  return rows
    .slice(1)
    .filter((cells) => cells.some((value) => value !== ""))
    .map((cells) => {
      const rowObj = {};
      h.forEach((hdr, index) => {
        rowObj[hdr] = cells[index];
      });
      return rowObj;
    });
}

document.addEventListener("DOMContentLoaded", () => {
  loadMapScripts(() => {
    createMap();
  });

  // Close button event listener
  const closeBtn = document.getElementById("closeMapKey");
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      const mapKey = document.getElementById("mapKey");
      if (mapKey) {
        mapKey.classList.remove("showKey");
        mapKey.classList.add("hideKey");
      }
    });
  }

  function capitalizeFirst(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const triggerBtn = document.getElementById("nearestStockist");
  if (triggerBtn) {
    triggerBtn.addEventListener("click", async () => {
      const pcode = document.getElementById("postcodeInput").value;
      if (pcode && pcode !== "") {
        const pc = await getPostcodeData(pcode);

        if (pc) {
          const rankByDistance = allLocs.sort((a, b) => {
            const distA = getDistance(pc.lng, pc.lat, a.lng, a.lat);
            const distB = getDistance(pc.lng, pc.lat, b.lng, b.lat);
            return distA - distB;
          });

          document.getElementById("mapKey").classList.add("showKey");
          document.getElementById("mapKey").classList.remove("hideKey");

          const as = `${capitalizeFirst(rankByDistance[0].Name)}, ${rankByDistance[0].address}`;

          document.getElementById("stockistName").innerText = rankByDistance[0].Name;
          document.getElementById("stockistAddress").innerText = as.replace(/,/g, ",\n");

          loadMap({ lat: rankByDistance[0].lat, lng: rankByDistance[0].lng, zoom: 18 });
        }
      }
    });
  }
});
